import React from "react";
import { Alert, Empty } from "antd";
import useClinicalRoleForms, { getReviewForm } from "../../../hooks/useClinicalRoleForms";
import ClinicalFormPanel from "./ClinicalFormPanel";
import LoadingIndicator from "../../Loaders/LoadingIndicator";
import { fromApiForm } from "../../../mappers/clinicalForms.mappers";

const ClinicalPractitionerReview = ({ admissionId, admissionType }) => {
  const { forms, loading, error } = useClinicalRoleForms(
    admissionId,
    admissionType
  );

  if (loading) return <LoadingIndicator message="Loading form" />;
  if (error) return <Alert type="error" message={error} showIcon />;

  const reviewForm = getReviewForm(forms);
  if (!reviewForm)
    return (
      <Empty
        style={{ marginTop: 60 }}
        description="No review form is configured for your role"
      />
    );

  return (
    <ClinicalFormPanel
      form={fromApiForm(reviewForm)}
      admissionId={admissionId}
      admissionType={admissionType}
      confirmExit
    />
  );
};

export default ClinicalPractitionerReview;
